import { render } from "./BaseInput.vue?vue&type=template&id=29488872&scoped=true&ts=true"
import script from "./BaseInput.vue?vue&type=script&lang=ts"
export * from "./BaseInput.vue?vue&type=script&lang=ts"

import "./BaseInput.vue?vue&type=style&index=0&id=29488872&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29488872"]])

export default __exports__